<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5">
      <div class="row">
        <div class="col-md-5">
          <lib-page-header page-title="PAGAMENTO DE RESTO A PAGAR"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            page-change="{{pagTitulo}}" show-change="true" image-title="assets/img/credit-card.png">
          </lib-page-header>
        </div>
        <div class="col-md-7">
          <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </a>
          <a [routerLink]="['/pagamentos-restos-pagar']" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm(false)" type="submit" class="btn btn-info float-right mr-4"
          style="font-size: 13px">Salvar Pagamento</button>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="row">
        <div class="col-md-8">
          <div class="form-row">
            <div class="form-group col-md-3 col-lg-3 col-xl-3">
              <label for="data_pagamento">Data pagamento<span class="text-danger">*</span></label>
              <p-calendar #InputFocus id="data_pagamento" formControlName="data_pagamento"
                inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true"
                [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
            <div class="form-group col-sm-2">
              <label for="liq">Empenho N˚<span class="text-danger">*</span></label>
              <input [(ngModel)]="empenhoNumero" [ngModelOptions]="{standalone: true}"
                type="text" class="form-control" id="liq">
            </div>
            <div class="form-group col-sm-2">
            <label for="ano" class="font-weight-bold" style="color: #009688">Ano</label>
            <input [(ngModel)]="ano" [ngModelOptions]="{standalone: true}" type="text"
              class="form-control text-right" (blur)="buscarLiquidacao()" id="ano">
          </div>
            <div class="form-group col-sm-1"
              *ngIf="this.entidadeForm.get('liquidacao').value && this.entidadeForm.get('liquidacao').value.parcela > 0">
              <label for="parcela" class="font-weight-bold" style="color: #009688">Parcela</label>
              <input [(ngModel)]="parcela" [ngModelOptions]="{standalone: true}" type="text" tabindex="-1"
                class="form-control text-right" (blur)="buscarLiquidacao()" id="parcela" placeholder="0">
            </div>
            <div class="form-group col-md-6 col-lg-5 col-xl-4">
              <label for="doc">Documento<span class="text-danger">*</span></label>
              <input formControlName="documento" type="text" class="form-control" id="doc">
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-row">
                <div class="form-group col-12 mb-0">
                  <input *ngIf="entidade.liquidacao"
                    value="{{entidade.liquidacao.empenho.favorecido.cpf_cnpj | CPF}} {{entidade.liquidacao.empenho.favorecido.nome}}"
                    readonly type="text" class="form-control-plaintext font-weight-bold" id="fav" tabindex="-1">
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-12 mb-0">
                  <input *ngIf="entidade.liquidacao"
                    value="{{entidade.liquidacao.empenho.acao}} {{entidade.liquidacao.empenho.acao_nome}}" readonly
                    type="text" class="form-control-plaintext" id="ficha" tabindex="-1">
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-12 mb-0">
                  <input *ngIf="entidade.liquidacao"
                    value="{{entidade.liquidacao.empenho.subelemento}} {{entidade.liquidacao.empenho.subelemento_nome}}"
                    readonly type="text" class="form-control-plaintext" id="subelemento" tabindex="-1">
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-12 mb-0">
                  <input *ngIf="entidade.liquidacao"
                    value="{{entidade.liquidacao.empenho.recurso}} {{entidade.liquidacao.empenho.recurso_nome}}"
                    readonly type="text" class="form-control-plaintext" id="recurso" tabindex="-1">
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-12 mt-0">
                  <input *ngIf="entidade.liquidacao"
                    value="{{entidade.liquidacao.empenho.aplicacao}} {{entidade.liquidacao.empenho.aplicacao_nome}}"
                    readonly type="text" class="form-control-plaintext" id="aplicacao" tabindex="-1">
                </div>
              </div>
            </div>
          </div>
          <hr class="mt-0 mb-3" />

          <div class="form-row">
            <div class="form-group col-md-2 col-lg-2 col-xl-2">
              <label for="conta_id">Ficha n˚<span class="text-danger">*</span></label>
              <input (blur)="buscarConta()" type="text" class="form-control font-weight-bold" id="conta_id"
                [(ngModel)]="contaId" name="conta_id" [ngModelOptions]="{standalone: true}">
            </div>
            <div class="form-group col-md-10 col-lg-10 col-xl-10">
              <label for="conta">Nome da conta bancária<span class="text-danger">*</span></label>
              <p-autoComplete id="conta" formControlName="conta" [field]="contaAutoComplete.conversor"
                [suggestions]="contaAutoComplete.lista" (completeMethod)="contaAutoComplete.filtrar($event)"
                placeholder="Digite o nome da conta" (onSelect)="changeConta()"
                inputStyleClass="form-control font-weight-bold" minLength="2" [style]="{ width: '100%' }"
                [forceSelection]="true" [autoHighlight]="true">
                <ng-template let-conta1 pTemplate="item">
                  {{conta1.numero_conta}} {{conta1.banco.nome}} {{conta1.nome}}
                </ng-template>
              </p-autoComplete>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-4">
              <label for="valor_pago">Valor a Pagar<span class="text-danger">*</span></label>
              <input unmask="true" [imask]="imaskConfig" formControlName="valor_pago" type="text" class="form-control"
                id="valor_pago" placeholder="0,00" style="font-weight: bold; color: #1e88e5">
            </div>

            <div class="form-group col-md-4">
              <label for="valor_retido">Total retido</label>
              <input readonly tabindex="-1" unmask="true" [imask]="imaskConfig" formControlName="valor_retido"
                type="text" class="form-control text-right" id="valor_retido" placeholder="0,00">
            </div>

            <div class="form-group col-md-4">
              <label for="valor_liquido">Total liquido</label>
              <input readonly tabindex="-1" unmask="typed" [imask]="imaskConfig" formControlName="valor_liquido"
                type="text" class="form-control text-right font-weight-bold" id="valor_liquido" placeholder="0,00">
            </div>
          </div>


        </div>
        <div class="col-md-4">
          <div class="card">
            <ul class="list-group list-group-flush">
              <li *ngIf="entidade.liquidacao" class="list-group-item">Vencimento <span
                  class="float-right">{{entidade.liquidacao.data_vencimento | date:'dd/MM/yyyy':'GMT'}}</span></li>
              <li class="list-group-item">Liquidado <span class="float-right">{{liquidado | number:'1.2-2'}}</span></li>
              <li class="list-group-item font-weight-bold">Saldo a pagar <span
                  class="float-right font-weight-bold">{{saldoPagar | number:'1.2-2'}}</span></li>
              <li class="list-group-item font-weight-bold">Saldo bancário <span
                  class="float-right font-weight-bold">{{saldoBancario | number:'1.2-2'}}</span></li>
            </ul>
          </div>
        </div>
      </div>


      <hr class="mt-3 mb-2" />
      <div class="form-row">
        <div class="form-group col-12">
          <label for="historico">Histórico</label>
          <textarea formControlName="historico" class="form-control" id="historico" rows="5"></textarea>
        </div>
      </div>

    </div>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="cvs" title="Sair" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>

  </form>
</div>